import {reactReduxModal as authModal} from './authModal';
import {loginUserRequest} from './loginUser';
import {refreshUserRequest} from './refreshUser';
import {resetPasswordRequest} from './resetPassword';
import {signupUserRequest} from './signupUser';

export const epics = [
  ...authModal.epics.epics,
  ...loginUserRequest.epics.epics,
  ...refreshUserRequest.epics.epics,
  ...resetPasswordRequest.epics.epics,
  ...signupUserRequest.epics.epics,
];



// WEBPACK FOOTER //
// ./src/js/auth/redux/index.js